<template>
    <div>
        <div v-if="!noImage" class="text-center padding_top_10 padding_bottom_5">
            <img v-bind:src="practiceDetails.Url" class="logo-frame">
        </div>
        <div class="padding_bottom_20">
            <ClientPracticeAddress/>
        </div>

        <NavigationLink/>
    </div>
</template>


<script>
import ClientPracticeAddress from './ClientPracticeAddress'
import NavigationLink from './NavigationLink'
import { mapGetters } from 'vuex'
export default {
    name: "sidebar",
    components: { ClientPracticeAddress, NavigationLink },
    computed: {
        ...mapGetters({
            clientPracticeDetails: 'clientPracticeDetails',
            selectedPractice: 'selectedPractice',
            noImage: 'noImage'
        }),
        practiceDetails: function () {
            if (this.selectedPractice != null) {
                return this.selectedPractice;
            }
            return this.clientPracticeDetails;
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/SideBar.vue